import React, { useState } from "react";
import FileList from "../Common/FileList";
import AddFileModal from "../Common/AddFileModal";
import { Button, Tooltip } from "flowbite-react";
import { HiOutlinePlus } from "react-icons/hi";
import { useAppSelector } from "../../Reducers/store";
import { UserLevelNames } from "../../Models/UserLevel";

const AdminFilesPage: React.FC = () => {
  const { userModel } = useAppSelector((state) => state.user);
  const [showAddFile, setShowAddFile] = useState<boolean>(false);
  const [reloadFiles, setReloadFiles] = useState<boolean>(false);

  const handleAddFileClick = () => {
    setShowAddFile(true);
  };

  return (
    <div className="w-full">
      <div className="w-full h-[74px] p-4">
        <div className="mx-1 flex items-end">
          <div className="flex flex-1">
            <h1 className="text-gray-900 font-bold text-4xl">Manage Files</h1>
          </div>
        </div>
      </div>
      <div className="float-right pr-6">
        {userModel && userModel.userLevelId === UserLevelNames.SuperAdmin && (
          <Tooltip content="Add File">
            <Button onClick={handleAddFileClick} className="buttonMain">
              <HiOutlinePlus />
            </Button>
          </Tooltip>
        )}
      </div>
      <FileList reload={reloadFiles} setReload={setReloadFiles} />
      <AddFileModal
        show={showAddFile}
        setShow={setShowAddFile}
        memberId={0}
        userId={0}
        setReload={setReloadFiles}
      />
    </div>
  );
};

export default AdminFilesPage;
